const ArrowSwiperIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24" // Increased width
      height="24" // Increased height
      viewBox="0 0 24 24" // Adjusted viewBox to match the new size
      fill="none"
    >
      <g id="Phosphor Icons / CaretRight">
        <path
          id="Vector"
          d="M9 4.5L16.5 12L9 19.5" // Adjusted path to match the new size
          stroke="#1C69D4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export default ArrowSwiperIcon;
